import { useEffect, useMemo, useState } from 'react';
import { Button, Divider, Flex, Table, Text } from '@keyslabor/shared/ui';
import PageContainer from '@keyslabor/shared/ui/layout/PageContainer/PageContainer';
import PageLayout from '@/components/PageLayout';
import getColumns from './columns';
import { useLostHoursListQuery } from '@/api/methods/useLostHoursListQuery.ts';
import { PlusIcon } from '@keyslabor/shared/assets/svgComponents';
import useDelete from './modals/useDelete';
import useBreakpoint from '@keyslabor/shared/hooks/useBreakPoint';
import useCreateLostHour from './modals/useCreateLostHour';
import CreateLostHourMobile from './CreateLostHourMobile';
import { useIsMobile } from '@keyslabor/shared/hooks/useBreakPoint';
import { useLostHoursEmployeesListQuery } from '@/api/methods/useLostHoursEmployeesListQuery.ts';

export default function LostHours() {
  const [step, setStep] = useState(0);
  const { data: lostHours } = useLostHoursListQuery();

  const isBreakpoint = useBreakpoint(567);
  const isMobile = useIsMobile();
  const { data: employees } = useLostHoursEmployeesListQuery();

  const [renderModalDelete, onDelete] = useDelete();

  const [renderCreateLostHour, toggleCreateLostHour] = useCreateLostHour();

  useEffect(() => {
    if (!isMobile) {
      setStep(0);
    }
  }, [isMobile]);

  const columns = useMemo(() => {
    return getColumns({ onDelete, isBreakpoint, isMobile });
  }, [onDelete, toggleCreateLostHour]);

  if (!employees) return null;

  const handlePlusClick = (isMobile: boolean) => {
    if (isMobile) {
      setStep(1);
      return;
    }
    toggleCreateLostHour();
  };

  if (step === 1) {
    return (
      <>
        <PageLayout>
          <CreateLostHourMobile setStep={setStep} />
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <PageLayout>
        <PageContainer
          padding={isMobile ? '20px 0px 0px 0px' : '20px'}
          minWidth={isMobile ? '100%' : undefined}
        >
          <Flex justifyContent="space-between" padding={isMobile && '0px 20px'}>
            <Flex flexDirection="column" maxWidth={isMobile && '300px'}>
              <Text fontWeight="700" fontSize={'20px'}>
                Lost hours
              </Text>
              <Text
                fontWeight="700"
                fontSize={isMobile ? '14px' : '20px'}
                color={'#EB5757'}
              >
                (all lost hours will be added to next invoice)
              </Text>
            </Flex>
            <Button kind="icon" onClick={() => handlePlusClick(isMobile)}>
              <PlusIcon />
            </Button>
          </Flex>
          <Flex padding={'0px 20px'}>
            <Divider mt="16px" mb="20px" />
          </Flex>
          <Flex padding={isMobile && '0px 20px'}>
            <Table
              pagination={{ pageSize: 8 }}
              rowKey="id"
              dataSource={lostHours}
              columns={columns}
              // notes if no padding than default, paddings are attached
              tableStyles={{
                disableBorderInlineEnd: isMobile,
                rowPadding: isMobile ? '6px' : undefined,
              }}
            />
          </Flex>
        </PageContainer>
      </PageLayout>
      {renderModalDelete}
      {renderCreateLostHour}
    </>
  );
}
